import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/waffers/strawberry waffer.png";
import BiscuitImg from "../../../assets/products/waffers/Strawberry-Waffers.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 6,
  },
  {
    grams: 7,
  },
  {
    grams: 16,
  },
  {
    grams: 18,
  },
];

export default function StrawberryWafferProduct() {
  return (
    <>
      <Helmet>
        <title>Strawberry Waffer – BearBitz | Premium Wafers & Biscuits</title>
        <meta
          name="description"
          content="Explore BearBitz Strawberry Wafers — crispy wafers layered with strawberry cream. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Strawberry Waffer, BearBitz Strawberry Wafers"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/waffers/strawberrywaffer"
        />
        <meta property="og:title" content="Strawberry Waffer – BearBitz" />
        <meta
          property="og:description"
          content="Delicious strawberry cream wafer biscuit by BearBitz, crafted for premium flavor and export quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="STRAWBERRY"
        productImage={BisImg}
        description="Crisp Layers, Creamy Delight Light, crunchy wafer layers filled with smooth cream in flavors like vanilla, chocolate, strawberry, and more. These biscuits offer a perfect bite of crisp and cream, making them a favorite among kids and teens. Easy to pack, easy to love – ideal for export markets worldwide."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF009F"
        sectionBgColor="#FFDBF4"
        productBgcolor="#FFADE6"
        tableheadBgcolor="#FF009F"
        tableBgcolor="#FFF1FB"
        footerBgcolor="#FF009F"
      />
    </>
  );
}
